export const QUERY_KEYS = {
  health: "health",
  checkDuplicateEmail: "check-duplicate-email",
  getRefreshToken: "get-refresh-token",
  getCustomerList: "get-customer-list",
  getSalesOfficeList: "get-sales-office-list",
  getCustomerDetails: "get-customer-details",
  getInvoiceList: "get-invoice-list",
  getInvoicePdf: "get-invoice-pdf",
  getSettings: "get-settings",
  getUserManual: "get-user-manual",
  getAdminManual: "get-admin-manual",
  getLogList: "get-log-list",
  getUserLog: "get-user-log",
  getBulkDownload: "get-bulk-download",
  resendPdf: "resend-pdf",
  resendBulkGuidance: "resend-bulk-guidance",
  getInvoiceImportList: "get-invoice-import-list",
};

export const MUTATION_KEYS = {
  updateInvoiceImportPublicationDate: "update-invoice-import-publication-date",
  updateInvoiceImportPublicationDateForSet:
    "update-invoice-import-publication-date-for-set",
  publishInvoiceImport: "publish-invoice-import",
  publishInvoiceImportSet: "publish-invoice-import-set",
  deleteInvoiceImport: "delete-invoice-import",
  downloadInvoiceImport: "download-invoice-import",
};
